module.exports = __webpack_public_path__ + "img/combo.1cb8745a.png";